<template>
  <div class="Footer-div">
    <div class="Footer-content">
      <div class="Footer-msg">
        <div class="Footer-item Footer-item1">
          <img src="../assets/images/Footer-icon0.png" />
          <ul>
            <li>
              <img src="../assets/images/Footer-icon1.png" />021-6173-2588
            </li>
            <li>
              <img
                src="../assets/images/Footer-icon2.png"
              />jasonl@global-rainbow.com
            </li>
            <li>
              <img
                src="../assets/images/Footer-icon3.png"
              />上海市静安区恒丰路436号环智国际大厦701单元
            </li>
          </ul>
        </div>
        <div class="Footer-item Footer-item2">
          <div class="Footer-item-one">
            <div class="Footer-item-title">产品中心</div>
            <ul>
              <router-link
                tag="li"
                v-for="(item, index) in productList"
                :key="index"
                style="cursor: pointor"
                :to="`/Products?id=${item.id}&name=${item.cpxh}`"
                >{{ item.cpxh }}</router-link
              >
            </ul>
          </div>
          <div
            class="Footer-item-one"
            v-for="(item, index) in nav"
            :key="item.id"
          >
            <div class="Footer-item-title">{{ item.name }}</div>
            <ul v-if="item.child">
              <router-link
                tag="li"
                v-for="(childItem, childIndex) in item.child"
                :key="childItem.id"
                style="cursor: pointor"
                :to="childItem.url"
                >{{ childItem.name }}</router-link
              >
            </ul>
          </div>
          <!-- <div class="Footer-item-one">
            <div class="Footer-item-title">应用方案</div>
            <ul>
              <li>生活电器</li>
              <li>个人健康</li>
              <li>无线遥控</li>
              <li>消费电子类</li>
            </ul>
          </div>
          <div class="Footer-item-one">
            <div class="Footer-item-title">服务支持</div>
            <ul>
              <li>用户手册</li>
              <li>说明文档</li>
              <li>Demo</li>
              <li>开发工具</li>
              <li>视频</li>
            </ul>
          </div>
          <div class="Footer-item-one">
            <div class="Footer-item-title">关于公司</div>
            <ul>
              <li>公司简介</li>
              <li>发展历程</li>
              <li>新闻资讯</li>
              <li>加入我们</li>
              <li>联系我们</li>
            </ul>
          </div> -->
        </div>
        <div class="Footer-item Footer-item3">
          <div class="Footer-scan">
            <img src="../assets/images/Footer-icon4.png" />
          </div>
          扫码关注
        </div>
      </div>
      <div class="Footer-footer">
        copyright 2023 上海菱沃泊智能技术有限公司 沪ICP备15018735号-1
      </div>
    </div>
  </div>
</template>

<script>
import request from "../util/request";
export default {
  data() {
    return {
      nav: [],
      productList: [],
    };
  },
  name: "Footer",
  props: [],
  async mounted() {
    let nav = await request.get("/nav/list");
    nav.splice(0, 2);
    this.nav = nav;
    let list = await request.get("/product/list");
    this.productList = list.splice(0, 5);
  },
  methods: {},
};
</script>

<style scoped>
.Footer-div {
  background-color: #efefef;
  padding-top: 40px;
  min-width: 1200px;
}
.Footer-content {
  width: 1200px;
  margin: 0 auto;
}
.Footer-msg {
  display: flex;
  justify-content: space-between;
  color: #787878;
  font-size: 14px;
}
.Footer-footer {
  font-size: 12px;
  color: #a9a9a9;
  text-align: center;
  padding: 20px 0px;
}
.Footer-item1 li {
  padding: 15px 0px;
}

.Footer-item1 li img {
  margin-right: 10px;
}
.Footer-item2 {
  flex-grow: 2;
  display: flex;
  justify-content: space-around;
  margin: 0px 50px;
}
.Footer-item2 li {
  padding: 10px 0px;
  cursor: pointer;
}

.Footer-item-title {
  color: #262626;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}

.Footer-item3 {
  text-align: center;
}
.Footer-scan {
  background-color: #fff;
  border-radius: 10px;
  padding: 5px;
  margin-bottom: 15px;
}
</style>